import initTab from '@components/tab';

const loadProfiles = () => {
	const profiles = document.querySelectorAll( '.wp-block-rte-profile' );

	if ( ! profiles ) {
		return;
	}

	profiles.forEach( ( block ) => {
		const tabList = block.querySelector( '.rte-profile-tabs' );
		if ( tabList ) {
			initTab( tabList );
		}
	} );
};

window.addEventListener( 'DOMContentLoaded', loadProfiles );
window.addEventListener( 'altisBlockContentChanged', loadProfiles );

// Enable HMR
if ( module.hot ) {
	module.hot.accept();
}
